import * as types from '../types';

const initialState = {
  email: '',
  name: '',
  username: '',
  profile: '',
  permissions: [],
  modalities: [],
  isLoadingUser: false,
  errors: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case types.REQUEST_USER_DATA:
      return { ...state, isLoadingUser: true, errors: null };

    case types.FETCH_USER_SUCCEEDED:
      return {
        ...state,
        email: action.payload.email,
        name: action.payload.name,
        username: action.payload.userName,
        profile: action.payload.userTypeName,
        permissions:
          (action.payload.claims &&
            action.payload.claims['permissions.policyholder']) ||
          [],
        modalities:
          (action.payload.claims &&
            action.payload.claims['modalities.policyholder']) ||
          [],
        isLoadingUser: false,
        errors: null
      };

    case types.FETCH_USER_FAILED:
      return { ...state, isLoadingUser: false, errors: action.payload };

    default:
      return state;
  }
};
